<template>
    <BomDuplicator></BomDuplicator>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const BomDuplicator = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/BomDuplicator/BomDuplicator.vue")
);

export default {
    name: "Project_BomDuplicator", //The name you are in should not equal the name of the component you are importing.
    components: { BomDuplicator, AuthLayout },
};
</script>
